import { render, staticRenderFns } from "./AppendixHandoverFile.vue?vue&type=template&id=4962dc3e&scoped=true"
import script from "./AppendixHandoverFile.vue?vue&type=script&lang=js"
export * from "./AppendixHandoverFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962dc3e",
  null
  
)

export default component.exports